<h1 class="my-3">Vous n'avez pas accès à l'application</h1>
<p>Bonjour, vous essayez d'accéder à une application réservée à des personnes autorisées, si vous souhaitez demander
    l'accès à l'application veuillez faire une demande dans <a href="https://terega.freshservice.com/support/tickets/new" target="_blank">Fresh Service</a>
</p>